import { FilterChoice } from '../../types/FilterChoice';
import { ALWAYS_ONLINE_BOOKED_TOPICS } from '../constants';
import { SuggestionTreatmentProfile } from './SuggestionTreatmentProfile';

export const treatmentFiltersFromProfiles = (
  profiles: SuggestionTreatmentProfile[],
): FilterChoice[] =>
  profiles.flatMap((profile): FilterChoice[] => {
    const { suburb, state, postcode } = profile;
    const location = { suburb: { name: suburb, state: state ?? undefined, postcode } };

    return [
      ...profile.interests.map(interest => ({
        location,
        topic: { treatment: interest },
        onlineAppointments: getOnlineAppointmentSetting(interest),
      })),
      ...profile.procedures.map(procedure => ({
        location,
        topic: { treatment: procedure },
        onlineAppointments: getOnlineAppointmentSetting(procedure),
      })),
    ];
  });

const getOnlineAppointmentSetting = (topic: string) =>
  ALWAYS_ONLINE_BOOKED_TOPICS.includes(topic) ? {} : undefined;
